module.exports = __webpack_public_path__ + "img/logo.91af3e2d.png";